// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_svg_relief/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_svg_relief: ModuleSchema = {
  "id": "core_svg_relief",
  "uniqueId": "B3D_SVG01",
  "createdAt": "2026-10-09T16:37:05.391Z",
  "updatedAt": "2026-10-09T16:38:34.199Z",
  "label": "SVG Relief Core",
  "description": "Reusable SVG path parser and embossed relief primitive with preserved holes.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SVG01",
    "svg",
    "relief"
  ],
  "sliders": [
    {
      "key": "targetHeight",
      "label": "SVG Height",
      "min": 1,
      "max": 100,
      "default": 15,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "extrusion",
      "label": "Extrusion",
      "min": 0.2,
      "max": 10,
      "default": 0.4,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "maxPaths",
      "label": "Vector Paths",
      "min": 1,
      "max": 32,
      "default": 2,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "relief",
      "label": "Relief",
      "default": "#123B8F",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
